// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
// import { connectFunctionsEmulator } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAubejR9vNUaP6unaY1rOa2vRKgGMXMTw0",
  authDomain: "ai-englemap.firebaseapp.com",
  projectId: "ai-englemap",
  storageBucket: "ai-englemap.appspot.com",
  messagingSenderId: "932953097845",
  appId: "1:932953097845:web:ff72da5d2055b89485da3c",
  measurementId: "G-SSCLF8ZBDF"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const firestore = getFirestore(app);
const functions = getFunctions(app, 'asia-northeast3');


/* for functions emulators
if(window.location.hostname === 'localhost') {
  connectFunctionsEmulator(functions, "localhost", 5001);
  //firebase.firestore().settings({ host: 'localhost:8080', ssl: false });
  //firebase.functions().useFunctionsEmulator('http://localhost:5001');
}
*/

export { auth, firestore, analytics, functions };
